// extracted by mini-css-extract-plugin
module.exports = {"informationTitle":"styles_informationTitle__3sUVl","container":"styles_container__roMz1"};
module.exports.__checksum = "9b6b48630c75"